var React = require('react');

function IconFacebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.023 28 18 21h-3v-3h3v-2c0-2.7 1.672-4 4.08-4 1.153 0 2.144.086 2.433.124v2.821h-1.67c-1.31 0-1.563.623-1.563 1.536V18H25l-1 3h-2.72v7h-3.257Z","fill":"currentColor"}));
}

IconFacebook.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = IconFacebook;

IconFacebook.default = IconFacebook;
